import { Checkbox, Hint, Input, Label } from 'components';
import { useTranslations } from 'next-intl';
import { useGithubData } from 'providers/IntegrationsProvider/useGithubData';
import { ChangeEvent, FC } from 'react';

interface INewRepositoryPersonalToken {
  useSameToken: boolean;
  toggleUseSameToken: () => void;
  personalToken: string;
  updatePersonalToken: (e: ChangeEvent<HTMLInputElement>) => void;
}

const NewRepositoryPersonalToken: FC<INewRepositoryPersonalToken> = ({
  useSameToken,
  toggleUseSameToken,
  personalToken,
  updatePersonalToken
}) => {
  const { data } = useGithubData();
  const t = useTranslations();

  if (!data?.githubRepos?.length || !data?.githubReposSingleToken)
    return (
      <>
        <Label>{t('integrations.github.personal_token')}</Label>
        <Input
          name="new-repository-token"
          type="text"
          value={personalToken}
          onChange={updatePersonalToken}
        />
        <Hint>{t('integrations.github.token_encryption')}</Hint>
      </>
    );

  return (
    <div>
      <Checkbox
        checked={useSameToken}
        onChange={toggleUseSameToken}
        name={'use-same-token'}
        label={t('integrations.github.use_same_token')}
        className="mb-4 mt-1"
      />
      {!useSameToken && (
        <>
          <Input
            name="new-repository-token"
            type="text"
            value={personalToken}
            onChange={updatePersonalToken}
          />
          <Hint>{t('integrations.github.token_encryption')}</Hint>
        </>
      )}
    </div>
  );
};

export default NewRepositoryPersonalToken;
